function setHeroHeight() {
    var setHeight = function () {
        var heroEl = document.querySelector('.article-header')
        if (!heroEl) return
        var {innerWidth} = window
        var isMobile = innerWidth < 900
        var height = innerWidth * (isMobile ? 1 : (7 / 16))
        heroEl.style.height = height + 'px'
    }
    setHeight()
    window.addEventListener('resize', setHeight)
}

if (document.readyState !== 'loading') {
    setHeroHeight()
} else {
    document.addEventListener('DOMContentLoaded', setHeroHeight)
}
